import { Slider } from "antd";
import {
  ContentsReward,
  InfoPrice,
  InputPrice,
  RowContents,
  WrapPrice,
  WrapSliderPrice,
} from "../../styled";
import { ButtonCommon } from "../../../../../../Layout/styled";
import { RemoveContainer } from "./styled";
import { convertFixed } from "../../../../../../utils/convertNumber";
import { useEffect, useState } from "react";
import LoadingSpin from "../../../../../../components/Common/Loading";
import { useWriteContract } from "wagmi";
import toast from "react-hot-toast";
import axios from "axios";
import { useDebouncedCallback } from "use-debounce";
import { useAppKitAccount } from "@reown/appkit/react";

const RemoveBoth = ({
  poolDetail,
  priceX,
  priceY,
  onChangeSlider,
  bin,
  range,
  numBins,
  slippageTolerance,
  setLoading,
  loading,
  minBinId,
  maxBinId,
  handleGetDataChart
}: any) => {
  const [isApproved, setIsApproved] = useState(false);
  const [resultRemove, setResultRemove] = useState<any>({});
  const { writeContractAsync } = useWriteContract();
  const { address } = useAppKitAccount();

  const debouncedHandleGetDataRemove = useDebouncedCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        "https://ap-dev-kibble.netlify.app/api/remove-v22",
        {
          wallet: address,
          tokenX: poolDetail?.tokenX.address,
          tokenY: poolDetail?.tokenY.address,
          minBin: minBinId,
          maxBin: maxBinId,
          lbBinStep: poolDetail?.lbBinStep,
        }
      );
      if (res) {
        setResultRemove(res?.data.ParamTX);
        setIsApproved(res?.data.isApproved);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      toast.error("Error fetching data");
      setLoading(false);
    }
  }, 500);

  const removeLiquidity = async () => {
    setLoading(true);
    try {
      const txParams = {
        address: resultRemove?.address,
        abi: resultRemove?.abi,
        functionName: resultRemove?.functionName,
        args: resultRemove?.args,
      };

      writeContractAsync(txParams)
        .then((hash) => {
          if (hash) {
            toast.success(
              isApproved
                ? "Transaction submitted"
                : "Approval transaction submitted"
            );
            setTimeout(() => {
              handleGetDataChart()
            }, 3000)
            setLoading(false);
          }
        })
        .catch((error: any) => {
          console.error("Transaction error:", error);
          toast.error("User rejected transaction");
          setLoading(false);
        });
    } catch (error: any) {
      console.log(error);
      toast.error(error.message || "Transaction failed");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (bin?.length > 0 && Number(minBinId) > 0 && Number(maxBinId) > 0) {
      debouncedHandleGetDataRemove();
    }
  }, [bin, minBinId, maxBinId, debouncedHandleGetDataRemove]);

  return (
    <RemoveContainer>
      <h2>Price Range</h2>
      <WrapSliderPrice
        style={{
          marginTop: "-10px",
          padding: "0 10px",
        }}
      >
        <Slider
          range={{ draggableTrack: false }}
          min={bin?.length > 0 ? bin[0]?.price : 0}
          max={bin?.length > 0 ? bin[bin?.length - 1]?.price : 0}
          value={range}
          step={
            bin?.length > 0
              ? (bin[bin?.length - 1]?.price - bin[0]?.price) /
                (bin?.length - 1)
              : 0
          }
          onChange={onChangeSlider}
          className="custom-slider"
          disabled={bin?.length === 0}
        />
      </WrapSliderPrice>
      <WrapPrice className="row-left">
        <InfoPrice>
          <p>Min Price</p>
          <InputPrice className="row-between">
            <input
              type="number"
              value={range[0] || ""}
              step="0.00000000000001"
              readOnly
            />
            <h2>
              {poolDetail?.tokenX.symbol}/{poolDetail?.tokenY.symbol}
            </h2>
          </InputPrice>
        </InfoPrice>
        <InfoPrice>
          <p>Max Price</p>
          <InputPrice className="row-between">
            <input
              type="number"
              value={range[1] || ""}
              step="0.00000000000001"
              readOnly
            />
            <h2>
              {poolDetail?.tokenX.symbol}/{poolDetail?.tokenY.symbol}
            </h2>
          </InputPrice>
        </InfoPrice>
        <InfoPrice>
          <p>Num Bins</p>
          <InputPrice className="row-center">
            <input type="number" value={numBins} readOnly />
          </InputPrice>
        </InfoPrice>
      </WrapPrice>
      <ContentsReward>
        <RowContents className="row-between remove">
          <p
            style={{
              marginBottom: "10px",
            }}
          >
            You will receive:
          </p>
          <div className="remove-receive">
            <div>
              <div className="img-token row-center">
                <img
                  style={{ borderRadius: "50%" }}
                  src={`https://img.lfj.gg/cdn-cgi/image/width=60,height=60/https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists-v2/refs/heads/main/logos/43114/${poolDetail?.tokenX?.address}.png`}
                  alt="img"
                />
              </div>
              <p>{convertFixed(priceX)}</p>
            </div>
            <div>+</div>
            <div>
              <div className="img-token row-center">
                <img
                  style={{ borderRadius: "50%" }}
                  src={`https://img.lfj.gg/cdn-cgi/image/width=60,height=60/https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists-v2/refs/heads/main/logos/43114/${poolDetail?.tokenY?.address}.png`}
                  alt="img"
                />
              </div>
              <p>{convertFixed(priceY)}</p>
            </div>
          </div>
        </RowContents>
        <RowContents className="row-between">
          <p>Price Range</p>
          <div className="row-right">
            <p>
              {convertFixed(range[0])} - {convertFixed(range[1])}{" "}
              {poolDetail?.tokenX?.symbol} per {poolDetail?.tokenY?.symbol}
            </p>
          </div>
        </RowContents>
        <RowContents className="row-between">
          <p>Amount Slippage Tolerance</p>
          <div className="row-right">
            <p>{slippageTolerance}%</p>
          </div>
        </RowContents>
        <RowContents className="row-between">
          <p>Minimum Expected {poolDetail?.tokenX.symbol}</p>
          <div className="row-right">
            <p>{convertFixed(priceX)}</p>
          </div>
        </RowContents>
        <RowContents className="row-between">
          <p>Minimum Expected {poolDetail?.tokenY.symbol}</p>
          <div className="row-right">
            <p>{convertFixed(priceY)}</p>
          </div>
        </RowContents>
        <div
          style={{
            display: "flex",
            gap: "10px",
          }}
        >
          {!isApproved ? (
            <ButtonCommon
              disabled={loading}
              onClick={() => {
                removeLiquidity();
              }}
            >
              {loading ? <LoadingSpin /> : "Approve"}
            </ButtonCommon>
          ) : (
            <ButtonCommon
              disabled={loading}
              onClick={() => {
                removeLiquidity();
              }}
            >
              {loading ? <LoadingSpin /> : "Remove Liquidity"}
            </ButtonCommon>
          )}
        </div>
      </ContentsReward>
    </RemoveContainer>
  );
};

export default RemoveBoth;
